module.exports = __webpack_public_path__ + "static/media/LogoNTU.53357698.png";